import { render, staticRenderFns } from "./InfoBarredor.vue?vue&type=template&id=07f81143&scoped=true&"
import script from "./InfoBarredor.vue?vue&type=script&lang=ts&"
export * from "./InfoBarredor.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBarredor.vue?vue&type=style&index=0&id=07f81143&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f81143",
  null
  
)

export default component.exports